module.exports = __webpack_public_path__ + "img/look3.1878decd.png";